import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "@/redux/reducers/auth";

export const store = configureStore({
    devTools: process.env.NODE_ENV === "development",
    reducer:{
        auth: authReducer
    }
})